import ExecuteAxios from "Components/ExecuteAxios/ExecuteAxios";
import Panel from "Components/Panel/Panel";
import React, { useEffect, useState } from "react";
import RightArrow from "../../../../../Components/SideBar/assets/icons/right-arrow.png"
import ApplyAttributes from "Components/ApplyAttributes/ApplyAttributes";
import AutomaticallyListedAttributes from "Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes";
import ResetVariables from "Components/ResetVariables/ResetVariables";
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';

const ExternalProductionCost = ({
    costDayIdSelecteds,
    currentMonth,
    handleClose,
    getButtonToShowSubtitles
}) => {
    const [idCostDaySelected, setIdCostDaySelected] = useState(null)
    const [productCode, setProductCode] = useState(null)
    const [dsOperation, setDsOperation] = useState(null)
    const [timePerOperation, setTimePerOperation] = useState(null)
    const [quantityOperations, setQuantityOperations] = useState(null)
    const [pricePerOperation, setPricePerOperation] = useState(null)
    const [username, setUsername] = useState(null);
    const [updateDate, setUpdateDate] = useState(null);

    const [externalProductionDataList, setExternalProductionDataList] = useState(null);
    const [externalProductionSelected, setExternalProductionSelected] = useState([]);
    const [costFixListDetail, setCostFixListDetail] = useState(null);
    const [updating, setUpdating] = useState(null);

    const attributeList = [
        { name: "id", value: idCostDaySelected, setter: setIdCostDaySelected, readOnly: 'S' },
        { name: "productCode", value: productCode, setter: setProductCode, readOnly: 'S' },
        { name: "dsOperation", value: dsOperation, setter: setDsOperation, readOnly: 'S' },
        { name: "timePerOperation", value: timePerOperation, setter: setTimePerOperation, readOnly: 'S' },
        { name: "quantityOperations", value: quantityOperations, setter: setQuantityOperations, readOnly: 'S' },
        { name: "pricePerOperation", value: pricePerOperation, setter: setPricePerOperation, readOnly: 'S' },
        { name: "username", value: username, setter: setUsername, readOnly: 'S' },
        { name: "dtUpdate", value: updateDate, setter: setUpdateDate, readOnly: 'S' }
    ];

    useEffect(() => {
        if (currentMonth) {
            setAttributesPanelGrid(currentMonth)
        } else {
            setAttributesPanelGrid(null)
        }
    }, []);

    useEffect(() => {
        if (externalProductionSelected && externalProductionSelected.length === 1) {
            setAttributesPanelDetail(externalProductionSelected[0])
        } else {
            setAttributesPanelDetail(0)
        }
    }, [externalProductionSelected]);

    const setAttributesPanelGrid = async (currentMonth) => {
        const parameters = { selectedMonthItem: currentMonth, selectedEmployeeId: costDayIdSelecteds[0] }
        const externalProductionDataList = await ExecuteAxios.api('get', `/external-production-operation/for-budget-grid/`, { params: parameters })
        setExternalProductionDataList(externalProductionDataList)
        if (externalProductionDataList) {
            ApplyAttributes.applyAttributes(externalProductionDataList, attributeList)
        }

        if (!costDayIdSelecteds || costDayIdSelecteds.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    const setAttributesPanelDetail = async (externalProductionSelected) => {
        const parameters = { selectedExternalProductionId: externalProductionSelected }
        const costDay = await ExecuteAxios.api('get', `/external-production-operation/for-budget-detail/`, { params: parameters })
        setCostFixListDetail(costDay)
        if (costDay) {
            ApplyAttributes.applyAttributes(costDay, attributeList)
        }

        if (!externalProductionSelected || externalProductionSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    const costDayStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '95%',
        zIndex: '0',
        overflow: 'hidden'
    }

    function getContentPanel() {
        if (!updating) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={setExternalProductionSelected}
                    idsSelected={externalProductionSelected}
                    data={externalProductionDataList}
                    attributeList={attributeList}
                />
            )
        } else {
            return (
                <AutomaticallyListedAttributes
                    list={costFixListDetail}
                    attributeList={attributeList}
                    readOnlyAttributes={!updating}
                />
            )
        }
    }

    return (
        <Panel titlePage={'Produções externas'}
            style={costDayStyle}
            updateNameButton="Ver"
            updating={updating}
            canEdit={true}
            enableEdit={true}
            setUpdating={setUpdating}
            canViewCRUD={true}
            recordsSelected={costDayIdSelecteds}
            dataListedAttributes={costFixListDetail}
            attributeList={attributeList}
            componentRightButtons={
                <button
                    style={{
                        backgroundImage: `url(${RightArrow})`,
                        backgroundSize: '30px 30px',
                        width: '35px',
                        height: '35px',
                        backgroundRepeat: 'no-repeat',
                        backgroundColor: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        alignItems: 'center'
                    }}
                    onClick={handleClose}
                />
            }
        >
            {getContentPanel()}
        </Panel>
    )
}

export default ExternalProductionCost;